import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StorageDataTransferComponent } from '../storage/components/storage-data-transfer/storage-data-transfer.component';
import { JobDetailsComponent } from './components/job-details/job-details.component';
import { JobMainPanelComponent } from './components/job-main-panel/job-main-panel.component';

import { JobListComponent } from './components/job-list/job-list.component';
import { JobParentListComponent } from './components/job-parent-list/job-parent-list.component';
import { UserRoleNames } from 'src/app/core/models/users';
import { JobTemplateListComponent } from './components/job-template-list/job-template-list.component';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';
import { SummaryComponent } from './components/summary/summary.component';

const routes: Routes = [
  {
    path: 'Jobs List',
    component: JobParentListComponent,
    canActivate: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin,UserRoleNames.PowerUser,UserRoleNames.DeploymentAdmin,UserRoleNames.JobOperator]},
  },
  {
    path: 'Jobs List/:cloudType/:deploymentName',
    component: JobMainPanelComponent,
    canActivate: [RouteGuard],
    data: {role: [UserRoleNames.GlobalAdmin,UserRoleNames.PowerUser,UserRoleNames.DeploymentAdmin,UserRoleNames.JobOperator]},
    children: [
      { path: 'Jobs', component: JobListComponent, children: [
        { path: ':jobName/jobDetails', component: JobDetailsComponent },
        { path: ':jobName/jobDetails/:pod', component: JobDetailsComponent },
        { path: ':jobName/storage/:storageName', component: StorageDataTransferComponent },
      ]},
      {
        path: 'Logs', component: ActionLogsComponent
      },
      { path: 'Queue', component: SummaryComponent },
      { path: 'Templates', component: JobTemplateListComponent },
      { path: '', redirectTo: 'Jobs', pathMatch: 'full' },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class JobsRoutingModule {}
